import { LoadingSpinner } from '@psyomics/ui-components';
import { Navigate } from 'react-router-dom';

import { LinkExpired } from '../../app/routes/referral/views/link-expired';
import { useReferralInviteQuery } from '../referral/hooks/use-referral-invite-query';

import { SurveyBuilder } from './components/survey-builder';
import { useInviteSurvey } from './hooks/use-invite-survey';
import { useQuestionnaireStartTracking } from './hooks/use-questionnaire-start-tracking';

interface SurveyProps {
  readonly invitePublicId: string;
}

const Survey = ({ invitePublicId }: SurveyProps) => {
  const { result, fetching, errorMessage } = useInviteSurvey(invitePublicId);
  const [invite, inviteFetching] = useReferralInviteQuery(invitePublicId);
  useQuestionnaireStartTracking(invitePublicId);

  if (fetching || inviteFetching) return <LoadingSpinner />;

  if (!invite || errorMessage === 'InviteNotFound') return <Navigate to={'/'} />;

  const { status } = invite.referralSession;
  if (status === 'expired') return <LinkExpired />;

  if (!result?.survey?.definition) throw new Error('no survey definition');

  return (
    <SurveyBuilder
      invitePublicId={invitePublicId}
      surveyJson={result.survey.definition}
      surveyResponseId={result.responseId}
    />
  );
};

export { Survey };
